<template>
    <div>
        <div v-for="(entry, index) in clonedEntries" :key="index" class="row form__row">
            <notification-input-row
                :email.sync="$v.entries.$each[index].email.$model"
                :push.sync="$v.entries.$each[index].push.$model"
                :placeholder="placeholder"
                @update:email="updateModel"
                @update:push="updateModel"
                :is-invalid="$v.entries.$each[index].email.$invalid"
                :is-dirty="$v.entries.$each[index].email.$dirty"
            />

            <div class="column-mobile-3" v-if="index === entries.length - 1 && index < 2">
                <button class="button button--large button--narrow" @click.prevent="newEntry()">
                    <i class="icon icon--action-add"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import { email } from 'vuelidate/lib/validators';
import NotificationInputRow from '@/components/NotificationInputRow';

export default {
    name: 'notification-input',
    components: {
        NotificationInputRow,
    },
    model: {
        prop: 'entries',
    },
    props: {
        placeholder: {
            type: String,
        },
        entries: {
            type: Array,
            required: true,
        },
    },
    computed: {
        clonedEntries() {
            return cloneDeep(this.entries);
        },
    },
    validations: {
        entries: {
            $each: {
                push: {},
                email: {
                    email,
                    unique(value) {
                        if (value === '') {
                            return true;
                        }

                        return filter(this.entries, { email: value }).length <= 1;
                    },
                },
            },
        },
    },
    methods: {
        updateModel() {
            this.$emit('input', this.clonedEntries);
        },
        newEntry() {
            let clone = cloneDeep(this.entries);

            clone.push({ email: '', push: false });

            this.$emit('input', clone);
        },
    },
};
</script>
